import script from "./PhoneField.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneField.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneField.vue?vue&type=style&index=0&id=4975828d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4975828d"]])

export default __exports__